import { useContext, useCallback, useMemo } from "react";
import { useState } from "react";
import { createContext } from "react";
import PitchContext from "./Pitch";
import TimezoneContext from "./Timezone";
import LocaleContext from "./Locale";
import { format } from "date-fns";
import useFetchPDF from "../hooks/useFetchPDF";
import PreferredViewContext from "./PreferredView"
import UnitSystemContext from "./UnitSystem";
import GridModeContext from "./GridMode";

const AnalysisPdfData = createContext()
export default AnalysisPdfData

export function AnalyisPdfDataProvider({ ...props }) {

    const [analysis, setAnalysis] = useState()
    const [tempestWeather, setTempestWeather] = useState()

    const { data: pitch } = useContext(PitchContext)
    const fetchPDFFromService = useFetchPDF()
    const { browserTimezone } = useContext(TimezoneContext)
    const { locale, datefnsLocale } = useContext(LocaleContext)
    const { preferredView } = useContext(PreferredViewContext)
    const { unitSystem } = useContext(UnitSystemContext)
    const { selectedMode: zoneResultsMode } = useContext(GridModeContext)

    const requestPayload = useMemo(() => {
        //tempest weather is optional
        if (!analysis || !pitch) return

        const tZ = pitch?.venue?.timeZone || browserTimezone
        const date = format(new Date(analysis?.date * 1000), 'PP', { locale: datefnsLocale })

        return {
            report: {
                reportType: 'analysisPage',
                formattedFromDate: date,
                reporterTz: tZ,
                locale: locale,
                isPerformanceView: preferredView === 'performance',
                unitSystem,
                zoneResultsMode,
            },
            analysis,
            pitch,
            tempestWeather,
        }

    }, [pitch, browserTimezone, datefnsLocale, locale, analysis, tempestWeather, unitSystem, zoneResultsMode])

    const dataReady = !!requestPayload

    const fetchPDF = useCallback(async () => {
        if (!dataReady) return

        try {
            await fetchPDFFromService(requestPayload, `${pitch.name}-${requestPayload.report.formattedFromDate}.pdf`)
        } catch (e) {
            console.log(e)
            throw new Error('Could not fetch PDF')
        }

    }, [requestPayload, dataReady, pitch, fetchPDFFromService])

    return <AnalysisPdfData.Provider
        value={{
            setAnalysis,
            setTempestWeather,
            dataReady,
            fetchPDF,
        }}
        {...props}
    />

}